import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps, Declaration } from '../../redux-store/types/api-types';
import { checkIfApplicationIsNonIndividual } from '../../utils/utilityFunctions';
import { SubHeading } from '../investors/components';
import { Gridstyles } from '../ApplicationDetails';
import React from 'react';
import { getAuthorizedSignatoryDeclaration } from '../SignatoriesInvestments/signatories-application';
import { getDeclaration } from './investor-application';
import { ListView } from '../commonComponents';

export const esignDeclaration = (declaration: string): JSX.Element => (
  <Typography sx={{ textAlign: 'justify' }}>{declaration}</Typography>
);

export const DeclarationMaster: { [key: string]: { [key: string]: string } } = {
  direct: {
    directInvestment: `I/We hereby declare that I/We have not made any payment of fee such as advisory fee or
  portfolio management fee to any placement agent(s)/channel partner(s)/distributor(s) in
  relation to my/our investment in the Fund.`,
    indirectInvestment: `I/We hereby declare that I/We have been onboarded through SEBI registered intermediary which
  is separately charging fees such as advisory fee or portfolio management fee in relation to
  my/our investment in the Fund.`,
  },
  ubo: {
    noIndividualOwnership: `Section I: We declare that no individual person holds directly **Controlling ownership in the
      captioned Company/Firm/LLP/AoP/BoI/ Trust above the prescribed threshold limit`,
    individualUbo: `Section II: I/We the undersigned hereby declare the below details of beneficial owners holding
  **Controlling ownership in the captioned Company/LLP/Firm/AoP/Bol above the prescribed
  threshold limit`,
    nonIndividualUbo: `Section III: Applicable only if there is/are non-individual Beneficial owner(s) holding
  Controlling** ownership as declared in Sec II.The following individual person(s), directly or
  indirectly, holds **Controlling ownership in the above captioned
  Company/Firm/LLP/AOP/Bol/Trust`,
  },
};

export const nriDeclaration = [
  `I/We, hereby acknowledge and confirm that I/We have initiated contact with Nippon Life India AIF Management Limited (NIAIF) to invest in the aif scheme and that I/We have not been previously approached by NIAIF to transact in the AIF scheme prior to my/our request and I/We hereby declare that the provision of information in relation to the AIF scheme and all communications between me/us and niaif are rendered by the latter on the basis of our own initiative on a reverse solicitation basis.`,
  `The scheme documents are strictly private and confidential and is being issued to investor(s) who are sophisticated investor(s) and who fully understand the features of the AIF scheme. The scheme documents must not be provided to any person other than the original recipient, and may not be reproduced or used for any other purpose.`,
];

type displayHeading = { direct: boolean; ubo: boolean };
const ShowDeclaration = (declaration: Declaration): displayHeading => {
  return {
    direct: declaration?.directInvestment || declaration?.indirectInvestment || false,
    ubo:
      declaration?.noIndividualOwnership ||
      declaration?.individualUbo ||
      declaration?.nonIndividualUbo ||
      false,
  };
};

export default function Declarations({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const declarations =
    application?.hasPOA || checkIfApplicationIsNonIndividual(application)
      ? getAuthorizedSignatoryDeclaration(application)
      : getDeclaration(application);

  const declaration = declarations && {
    directInvestment: declarations?.directInvestment,
    nonIndividualUbo: declarations?.nonIndividualUbo,
    individualUbo: declarations?.individualUbo,
    noIndividualOwnership: declarations?.noIndividualOwnership,
    indirectInvestment: declarations?.indirectInvestment,
    nriDeclaration: declarations?.nriDeclaration,
  };
  return Object.values(declaration || {}).includes(true) ? (
    <Box
      sx={{
        bgcolor: 'white',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
        borderRadius: '10px',
      }}
      mt={5}>
      <Box sx={{ p: 2 }}>
        <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
          <Typography
            sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', mb: 2 }}></Typography>
          {Object.keys(DeclarationMaster)
            .filter(
              (item) =>
                (item === 'direct' &&
                  (declaration?.directInvestment || declaration?.indirectInvestment)) ||
                (item === 'ubo' &&
                  (declaration?.nonIndividualUbo ||
                    declaration?.individualUbo ||
                    declaration?.noIndividualOwnership))
            )
            .map((items) => {
              return (
                declaration && (
                  <>
                    <SubHeading
                      sx={{
                        letterSpacing: 0.5 + 'px',
                        padding: { xs: '10px 10px', sm: '10px 30px' },
                        fontWeight: 700,
                      }}>
                      {items === 'direct' && ShowDeclaration(declaration)[items]
                        ? 'Declaration for Direct Plan Investor'
                        : 'UBO Declaration'}
                    </SubHeading>
                    {Object.keys(DeclarationMaster[items]).map((item) => {
                      return (
                        declaration[item as keyof Declaration] && (
                          <Box sx={{ width: '100%' }}>
                            <Gridstyles>
                              <Grid
                                item
                                container
                                pb={5}
                                rowSpacing={6}
                                columnSpacing={13}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="flex-start">
                                <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                                  <Typography>
                                    {esignDeclaration(DeclarationMaster[items][item])}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Gridstyles>
                          </Box>
                        )
                      );
                    })}
                  </>
                )
              );
            })}
          {declaration?.nriDeclaration && (
            <>
              <SubHeading
                sx={{
                  letterSpacing: 0.5 + 'px',
                  padding: { xs: '10px 10px', sm: '10px 30px' },
                  fontWeight: 700,
                }}>
                {'NRI Declaration'}
              </SubHeading>
              <Gridstyles>
                <ListView list={nriDeclaration} />
              </Gridstyles>
            </>
          )}
        </Grid>
      </Box>
    </Box>
  ) : (
    <></>
  );
}
